export const SET_LOADING = '@orderDetails/SET_LOADING';
export const SAVE_DATA = '@orderDetails/SAVE_DATA';
export const SET_CITY_FILTER = 'SET_CITY_FILTER';
export const SET_AMOUNT_FILTER = 'SET_AMOUNT_FILTER';
